import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-[#09090b] text-white p-8 flex flex-col items-center justify-center gap-6">
      <h1 className="text-3xl font-bold">Page not found</h1>
      <p>The page you requested is not available.</p>
      <Link className="text-sky-400 underline" to="/">Return to Xavier Assembly</Link>
    </main>
  );
}
